// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-text[data-v-7c63965e]{margin-right:8px}.news-list .news-card .news-name[data-v-7c63965e]:hover{color:#0c3a93}", ""]);
// Exports
module.exports = exports;
